import { Connection } from "@solana/web3.js";
import { fetchUnstakeTime, getCurrentEpochInfo } from "./epoch";

export const getEstimatedWithdrawalWait = async (
  connection: Connection
): Promise<string | null> => {
  const epochInfo = await getCurrentEpochInfo(connection);
  const { estimatedTimeToClaim } = fetchUnstakeTime(epochInfo.absoluteSlot, epochInfo);
  return estimatedTimeToClaim;
};
